module.exports = __webpack_public_path__ + "static/media/share-icon.a7c58daa.svg";